/**
 * AppsFlyer Event Names
 * Centralized event names for consistency
 */
export const APPSFLYER_EVENTS = {
  // Attribution & Install Events
  INSTALL_OPEN_ATTRIBUTED: "install_open_attributed",
  UNINSTALL_SUSPECTED: "uninstall_suspected",

  // Session & Engagement
  APP_SESSION_STARTED: "app_session_started",
  CAMPAIGN_DEEPLINK_OPEN: "campaign_deeplink_open",

  // Onboarding Flow
  ONBOARDING_STARTED: "onboarding_started",

  // Consent Events
  PRIVACY_POLICY_ACCEPTED: "privacy_policy_accepted",
  DATA_CONSENT_ACCEPTED: "data_consent_accepted",
  MARKETING_CONSENT_ACCEPTED: "marketing_consent_accepted",

  // Registration
  REGISTRATION_GATE_VIEWED: "registration_gate_viewed",
  SIGNUP_COMPLETED: "signup_completed",

  // Guide Quiz Journey
  GUIDE_QUIZ_STARTED: "guide_quiz_started",
  GUIDE_QUIZ_PROGRESSED: "guide_quiz_progressed",
  GUIDE_QUIZ_COMPLETED: "guide_quiz_completed",
  PERSONALIZED_RESULT_VIEWED: "personalized_result_viewed",

  // Commerce
  PRODUCT_PAGE_VIEWED: "product_page_viewed",
  BUY_NOW_BUTTON_CLICKED: "buy_now_button_clicked",

  // Symptom Tracker
  SYMPTOM_TRACKER_FIRST_ENTRY: "symptom_tracker_first_entry",
  SYMPTOM_ENTRY_LOGGED: "symptom_entry_logged",

  // Content
  ARTICLE_OPENED: "article_opened",

  // Navigation
  TAB_SWITCHED: "tab_switched",
} as const;

export const APPSFLYER_CONSENT_GROUPS = {
  ANALYTICS_COOKIE_GROUP: "C0002",
  TARGETING_COOKIE_GROUP: "C0004",
} as const;
